export const ALIAS_TOKEN = 'alias-token';
export const IS_SERVICE_AGENT = 'isServiceAgent';
export const ALIAS_EMAIL = 'aliasEmailAddress';
export const DO_LOGIN = 'uiState/authState/DO_LOGIN';
export const DO_REGISTER = 'uiState/authState/DO_REGISTER';
export const VERIFY_CUSTOMER = 'uiState/authState/VERIFY_CUSTOMER';
export const CREATE_PASSWORD = 'uiState/authState/CREATE_PASSWORD';
export const FORGOT_PASSWORD = 'uiState/authState/FORGOT_PASSWORD';
export const RESEND_VERIFICATION = 'uiState/authState/RESEND_VERIFICATION';
export const MIGRATE_ACCOUNT = 'uiState/authState/MIGRATE_ACCOUNT';
export const NEW_PASSWORD = 'uiState/authState/NEW_PASSWORD';
export const CHECK_TOKEN = 'uiState/authState/CHECK_TOKEN';
export const DO_LOGOUT = 'uiState/authState/DO_LOGOUT';
export const GET_STATUS = 'uiState/authState/GET_STATUS';
export const REFRESH_TOKEN = 'uiState/authState/REFRESH_TOKEN';
export const GET_PROFILE_DATA = 'uiState/authState/GET_PROFILE_DATA';
export const SET_TOKEN = 'uiState/authState/SET_TOKEN';
export const RESET_ERRORS = 'uiState/authState/RESET_ERRORS';
export const TOGGLE_COMPONENT = 'uiState/authState/TOGGLE_COMPONENT';